
const state = {
  id: undefined,
  brand_id: undefined,
  permission_data: {},
  profile_type: '',
  role_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'permission_data' },
  { key: 'profile_type' },
  { key: 'role_id' },
  { key: 'title' },
]

export default state
